<div class="table-container" *ngIf="dataTable">
    <p-table [autoLayout]="true" [(selection)]="selected" (onRowSelect)="onRowSelect($event)" [scrollable]="true"
        [resizableColumns]="true" [value]="dataTable" [tableStyle]="{ 'min-width': '50rem' }"
        scrollHeight="{{scrollHeight}}" styleClass="p-datatable-striped" responsiveLayout="stack"
        [paginator]="(dataSource.length > 4)" [rowsPerPageOptions]="[5,10,50,100]" [rows]="10"
        (onPage)="paginate($event)" [first]="first">
        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <!-- Sticky No column -->
                <th class="sticky-column-index">
                    No
                </th>
                <!-- Sticky first column -->
                <th class="sticky-column" [ngClass]="{'stretch': visibleColumns.length === 1}">
                    {{ fixedColumnHeader.label }}
                </th>
                <!-- Dynamic columns -->
                <th *ngFor="let col of visibleColumns" [pSortableColumn]="col.value">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span>{{ col.label }}</span>
                        <div style="display: flex; align-items: center; gap: 4px;">
                            <!-- Sort Icon -->
                            <p-sortIcon *ngIf="col.sort" field="{{ col.value }}"></p-sortIcon>
                            <!-- Filter Icon -->
                            <p-columnFilter *ngIf="col.filter" field="{{ col.value }}" display="menu"
                                [matchModeOptions]="[
                                    { label: 'Starts With', value: 'startsWith' },
                                    { label: 'Contains', value: 'contains' },
                                    { label: 'Ends With', value: 'endsWith' }
                                ]"></p-columnFilter>
                        </div>
                    </div>
                </th>
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-rowData>
            <tr (click)="rowClicked(rowData)">
                <!-- Sticky No column -->
                <td class="sticky-column-index">
                    {{ rowData['index'] }}
                </td>
                <!-- Sticky first column -->
                <td class="sticky-column" [ngClass]="{'stretch': visibleColumns.length === 1}">
                    {{ rowData[fixedColumnHeader.value] }}
                </td>
                <!-- Dynamic columns -->
                <td *ngFor="let col of visibleColumns">
                    <p-tableCheckbox *ngIf="col.value == 'checkbox'" [value]="rowData" />
                    <div class="fixed-checkbox-col" class="dotStyle" *ngIf="col.customTemplate && col.template" (click)="$event.stopPropagation()">
                        <ng-container *ngTemplateOutlet="col.template; context: { context: rowData }"></ng-container>
                    </div>
                    <div *ngIf="!col.customTemplate">
                        {{ rowData[col.value] }}
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="empty-table" *ngIf="!dataSource || dataSource.length === 0">
        <span>No data available</span>
    </div>
</div>